import { Content } from '../../types';

export const kohRongSanloemContent: Content = {
  title: 'קו רונג סנלואם – אי של שלווה ורוגע',
  imageUrl: 'https://tinyurl.com/koh-rong-sanloem-wide',
  introduction: `אם קו רונג מציע שילוב של חיי לילה וחופים מרהיבים, האי קו רונג סנלואם הוא היעד המושלם לאלו המחפשים שקט מוחלט, חופים בתוליים ואווירה רומנטית.`,
  sections: [
    {
      title: 'החופים המרהיבים של האי',
      content: `קו רונג סנלואם קטן יותר משכנו הגדול, אך ידוע בחופיו עוצרי הנשימה. החוף המפורסם ביותר הוא Saracen Bay, אשר מאופיין במים רדודים, חול לבן ורך ועצי קוקוס המקנים לו אווירה חלומית. מי שמחפש חוויה מבודדת יותר, יכול להגיע ל-Lazy Beach, חוף פראי ושליו עם שקיעות מדהימות.`,
      type: 'text',
    },
    {
      title: 'אטרקציות ופנאי',
      content: `קו רונג סנלואם הוא יעד אידיאלי לאוהבי השלווה והטבע. האי מציע מסלולי הליכה ייחודיים העוברים בין היערות הירוקים והחופים הנסתרים. בנוסף, ניתן ליהנות מצלילה ושנורקלינג במים הצלולים העשירים בחיים ימיים. גם כאן ניתן למצוא את תופעת הפלנקטון הזוהר בלילה.`,
      type: 'text',
    },
    {
      title: 'לינה באי',
      content: `האופציות ללינה באי מתאימות לאלו המחפשים רוגע ונוחות. The One Resort ו-Pearl Resort מציעים חוויית אירוח מפנקת עם גישה ישירה לחוף. מי שמעדיף אווירה פשוטה יותר, יוכל למצוא גסטהאוסים חביבים לאורך המפרץ.`,
      type: 'text',
    },
    {
      title: 'איך מגיעים?',
      content: `בדומה לקו רונג, המעבורות לסנלואם יוצאות מסיהאנוקוויל, אך הנסיעה קצרה יותר ונמשכת כ 40-50 דקות. ניתן לבחור בין סירות מהירות למעבורות איטיות יותר.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `קו רונג וקו רונג סנלואם הם שני יעדים קסומים בקמבודיה וכל אחד מהם מציע חוויה שונה – מהשילוב בין חיי לילה ורוגע בקו רונג ועד השלווה והפסטורליות של קו רונג סנלואם. לא משנה איזה אי תבחרו, החוויה תהיה בלתי נשכחת!`,
      type: 'text',
    },
  ],
};
